import { FC, Fragment } from 'react';
import { observer } from 'mobx-react';

import { Snackbar, Toast } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';

import { NotificationCenterStore } from '../stores/notification-center.store';

export const NotificationCenter: FC = observer(() => {
    const [store] = useDependencies(NotificationCenterStore);

    return (
        <Fragment>
            <Toast.Group portal>
                {store.toastItems.map(item => (
                    <Toast
                        key={item.key}
                        status={item.notification.status}
                        title={item.notification.title}
                        duration={15000}
                        portal={false}
                        onClose={item.handleClose}
                    >
                        {item.notification.message}
                    </Toast>
                ))}
            </Toast.Group>
            {store.snackbarItems.map(item => (
                <Snackbar key={item.key} title={item.title} portal onClose={item.handleClose} />
            ))}
        </Fragment>
    );
});

NotificationCenter.displayName = 'NotificationCenter';
